import moment from "moment";

export const formatPricerDate = (value, format) => {
  if (!value) {
    return "-";
  }
  const parsed = moment(
    value,
    [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY"],
    true,
  );
  return parsed.isValid() ? parsed.format(format) : "-";
};
